import React, { useEffect, useState } from "react";
import classNames from "classnames";
import copyButtonStyles from "./CopyButton.module.scss";
import { CopyReplicateIcon as CopyIcon, DownloadIcon } from "@netapp/bxp-style/react-icons/Action";
import { CSSTransition } from "react-transition-group";
import ReactDOM from "react-dom";
import _ from "lodash";
import { FormFieldInputNew, FormFieldInputButton } from "../Forms"
import { saveToDisk } from "../../utils"
import { TooltipContent } from "./Tooltip";

export const FormFieldDownloadButton = ({ contents, fileName, onDownload, includeLabel, dataTestId }) => {
    const onClick = onDownload ? onDownload : () => saveToDisk(contents, fileName);

    return <FormFieldInputButton Icon={DownloadIcon} onClick={onClick} dataTestId={dataTestId} label={includeLabel ? "Download" : undefined}/>
}

export const FormFieldCopyButton = ({ text: _text, includeLabel, dataTestId }) => {
    const [showBubble, setShowBubble] = useState(false);
    const [bubblePosition, setBubblePosition] = useState({});
    const buttonRef = React.createRef();
    const bubbleRef = React.createRef();
    const text = _.isObject(_text) ? JSON.stringify(_text, null, 4) : _text;

    useEffect(() => {
        if (showBubble && buttonRef.current) {
            const { top, left, width } = buttonRef.current.getBoundingClientRect();
            const maxWidth = document.body.clientWidth;
            let isLeft = false;
            if (left + width + 60 > maxWidth) {
                isLeft = true;
            }

            setBubblePosition({ top: top - 31, left: left + (isLeft ? 0 : width), isLeft })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showBubble]);

    const onClickHandler = () => {
        navigator.clipboard.writeText(text).then(() => {
            setShowBubble(true);
            setTimeout(() => {
                setShowBubble(false);
            });
        }).catch((error) => {
            console.error(error);
        });
    };

    return <>
        <FormFieldInputButton onClick={onClickHandler} dataTestId={dataTestId} Icon={CopyIcon} ref={buttonRef} label={includeLabel ? "Copy" : undefined}>
            <CSSTransition nodeRef={bubbleRef} in={showBubble} unmountOnExit timeout={1000}>
                    <span ref={bubbleRef} style={{ position: "absolute" }}>
                        {ReactDOM.createPortal(<div className={classNames(copyButtonStyles['bubble'], { [copyButtonStyles['left']]: bubblePosition.isLeft })} style={{ top: bubblePosition.top, left: bubblePosition.left }}>
                            <TooltipContent>Copied!</TooltipContent></div>, document.body)}
                    </span>
            </CSSTransition>
        </FormFieldInputButton>
    </>
};

export default ({ text, download, onDownload, includeLabel, dataTestId, ...rest }) => {
    return (
        <FormFieldInputNew dataTestId={dataTestId && `${dataTestId}-input`} {...rest} value={text} inputButtons={
            <>
                <FormFieldCopyButton dataTestId={dataTestId && `${dataTestId}-copy-button`} includeLabel={includeLabel} text={text}/>
                {(download || onDownload) && <FormFieldDownloadButton includeLabel={includeLabel} onDownload={onDownload} contents={download.contents} fileName={download.fileName} dataTestId={dataTestId && `${dataTestId}-download-button`}/>}
            </>
        }/>
    )
};
